import { __assign, __extends, __rest, __spreadArrays } from "tslib";
import { CoherencePanel } from '@cseo/coherence-panel';
import { isPanelHeightSufficient } from '@cseo/coherence-utilities';
import { classNamesFunction, Link, Stack } from '@fluentui/react';
import dayjs from 'dayjs';
import moment from 'moment';
import React from 'react';
import { CoherenceNotificationItem } from '../index';
var CoherenceNotificationPanelBase = (function (_super) {
    __extends(CoherenceNotificationPanelBase, _super);
    function CoherenceNotificationPanelBase(props) {
        var _this = _super.call(this, props) || this;
        _this._getClassNames = classNamesFunction();
        _this.handleResize = function () {
            if (!_this.state.isShort && !isPanelHeightSufficient()) {
                _this.setState({ isShort: true });
            }
            else if (_this.state.isShort && isPanelHeightSufficient()) {
                _this.setState({ isShort: false });
            }
        };
        _this.showNotificationData = function () {
            _this.setState({ isRenderNotificationContent: false });
        };
        _this.showNotificationList = function () {
            _this.setState({ isRenderNotificationContent: true });
        };
        _this.onSetCurrentNotificationItem = function (item) {
            _this.setState({ currentNotificationItem: item });
        };
        _this.displayNotificationItemData = function () {
            var _a, _b;
            return (React.createElement("div", null,
                React.createElement("div", { className: _this._classNames.subjectHeaderOnOpen }, (_a = _this.state.currentNotificationItem) === null || _a === void 0 ? void 0 : _a.subjectHeader),
                React.createElement("div", { className: _this._classNames.messageBodyOnOpen },
                    React.createElement("div", { className: _this._classNames.messageBodyContentOnOpen, dangerouslySetInnerHTML: {
                            __html: (_b = _this.state.currentNotificationItem) === null || _b === void 0 ? void 0 : _b.messageBodyText
                        } }))));
        };
        _this.displayNotificationData = function () {
            var _a, _b, _c;
            var sortedItems = processNotifications(_this.props.items);
            var groups = getGroups(sortedItems, _this.props.timeGroupLabels);
            if (!sortedItems || !sortedItems.length) {
                return (React.createElement("div", { className: _this._classNames.rootNoNotifications }, (_a = _this.props.noNotificationsMessage) !== null && _a !== void 0 ? _a : 'No notifications'));
            }
            else if (_this.props.onUndoDismissAll && _this.props.isUndoDismissAllVisible) {
                return (React.createElement(Stack, { className: _this._classNames.rootNoNotifications },
                    React.createElement("div", { className: _this._classNames.undoView }, (_b = _this.props.allNotificationsDismissedMessage) !== null && _b !== void 0 ? _b : 'All notifications have been dismissed'),
                    React.createElement(Link, { className: _this._classNames.undoView, id: 'coher-notificationPanel-undo-id', href: 'javascript:void(0)', onClick: _this._onUndoDismissAllClicked }, (_c = _this.props.undoDismissNotificationsText) !== null && _c !== void 0 ? _c : 'Undo')));
            }
            else {
                return groups.map(function (g) {
                    return (React.createElement("ul", { key: g.key, style: { margin: 0, padding: 0 }, "aria-label": g.name },
                        _this._onRenderHeader(g),
                        _this._onRenderGroupedItems(g, sortedItems),
                        _this._onRenderFooter(g)));
                });
            }
        };
        _this._onRenderGroupedItems = function (group, allItems) {
            var renderedItems = [];
            for (var i = group.startIndex; i < group.startIndex + group.count; i++) {
                renderedItems.push(React.createElement("li", { style: { listStyle: 'none' } }, _this._onRenderCell(0, allItems[i])));
            }
            return renderedItems;
        };
        _this._onUndoDismissAllClicked = function () {
            if (_this.props.onUndoDismissAll) {
                _this.props.onUndoDismissAll();
            }
        };
        _this._onRenderCell = function (_nestingDepth, item) {
            return (React.createElement(CoherenceNotificationItem, { item: item, openItem: _this.props.openItem, showNotificationList: _this.showNotificationList, updateItem: _this.props.updateItem, onSetCurrentNotificationItem: _this.onSetCurrentNotificationItem, notificationDismissedMessage: _this.props.singleNotificationDismissedMessage, timeGroupLabels: _this.props.timeGroupLabels, itemActionsText: _this.props.notificationItemActionsText, dateFormatter: _this.props.dateFormatter, timeFormatter: _this.props.timeFormatter }));
        };
        _this._onRenderHeader = function (group) {
            return (React.createElement(Stack, { className: _this._classNames.groupHeaderRow, horizontal: true },
                React.createElement("h2", { className: _this._classNames.groupHeaderText }, group.name)));
        };
        _this._onRenderFooter = function (group) {
            if (group && _this.props.items) {
                if (_this.props.items.length >
                    group.startIndex + group.count) {
                    return React.createElement("div", { className: _this._classNames.groupFooterRow });
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        };
        _this._onRenderFooterContent = function () {
            var _a;
            var _b = _this.props, onDismissMultiple = _b.onDismissMultiple, isUndoDismissAllVisible = _b.isUndoDismissAllVisible, footerActionText = _b.footerActionText, footerActionProps = _b.footerActionProps, dismissAllText = _b.dismissAllText, dismissAllAriaLabel = _b.dismissAllAriaLabel;
            var _c = _this.state, currentNotificationItem = _c.currentNotificationItem, isRenderNotificationContent = _c.isRenderNotificationContent;
            return (React.createElement("div", null,
                onDismissMultiple && !isUndoDismissAllVisible && !isRenderNotificationContent && (React.createElement(Link, { className: _this._classNames.dismissAllText, "aria-label": dismissAllAriaLabel !== null && dismissAllAriaLabel !== void 0 ? dismissAllAriaLabel : 'Dismiss all notifications', href: 'javascript:void(0)', onClick: _this._onDismissAll }, dismissAllText !== null && dismissAllText !== void 0 ? dismissAllText : 'Dismiss all')),
                (!isRenderNotificationContent && footerActionText && footerActionProps) && (React.createElement(Link, __assign({ className: _this._classNames.footerAction }, footerActionProps), footerActionText)),
                (isRenderNotificationContent && currentNotificationItem && currentNotificationItem.actionRequiredLink && currentNotificationItem.actionRequiredText) &&
                    React.createElement(Link, { "aria-label": (((_a = currentNotificationItem.senderName) === null || _a === void 0 ? void 0 : _a.concat(' ')) || '') + currentNotificationItem.subjectHeader + ' ' + currentNotificationItem.actionRequiredText, href: currentNotificationItem.actionRequiredLink, onClick: _this._actionTextClicked }, currentNotificationItem.actionRequiredText)));
        };
        _this._actionTextClicked = function (event) {
            event.stopPropagation();
        };
        _this._onDismissAll = function () {
            var onDismissMultiple = _this.props.onDismissMultiple;
            if (onDismissMultiple && _this.props.items) {
                var keys = _this.props.items && _this.props.items.map(function (x) { return x.itemKey; });
                onDismissMultiple(keys);
            }
        };
        _this.state = {
            isShort: !isPanelHeightSufficient(),
            isRenderNotificationContent: false,
            currentNotificationItem: undefined
        };
        return _this;
    }
    CoherenceNotificationPanelBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, styles = _a.styles, theme = _a.theme, panelSize = _a.panelSize, titleText = _a.titleText, backButton = _a.backButton, remainingProps = __rest(_a, ["styles", "theme", "panelSize", "titleText", "backButton"]);
        this._classNames = this._getClassNames(styles, { theme: theme, isFooterInBody: this.state.isShort, panelSize: panelSize });
        return (React.createElement(CoherencePanel, __assign({ panelBodyResponsiveMargin: false, panelSize: panelSize }, remainingProps, { titleText: titleText || 'Notifications', isOpen: this.props.isOpen, onDismiss: this.props.onDismissPanel, onRenderFooter: this._onRenderFooterContent, backButton: this.state.isRenderNotificationContent ? {
                text: (backButton === null || backButton === void 0 ? void 0 : backButton.text) || 'back',
                ariaLabel: (backButton === null || backButton === void 0 ? void 0 : backButton.ariaLabel) || 'back',
                onClick: function () {
                    _this.showNotificationData();
                }
            } : undefined }),
            !this.state.isRenderNotificationContent && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: this._classNames.headerBody }, this.props.headerBody) || null,
                React.createElement("div", { className: this._classNames.rootNotifications }, this.displayNotificationData()))),
            this.state.isRenderNotificationContent &&
                this.displayNotificationItemData()));
    };
    CoherenceNotificationPanelBase.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize);
    };
    CoherenceNotificationPanelBase.prototype.componentDidUpdate = function (_) {
        if (this.props.onUndoDismissAll && this.props.isUndoDismissAllVisible) {
            var undoLink = (document.getElementById('coher-notificationPanel-undo-id'));
            if (undoLink) {
                undoLink.focus();
            }
        }
    };
    CoherenceNotificationPanelBase.prototype.componentWillUnmount = function () {
        var _this = this;
        window.removeEventListener('resize', function () { return _this.handleResize; });
    };
    return CoherenceNotificationPanelBase;
}(React.Component));
export { CoherenceNotificationPanelBase };
function getGroups(items, timeGroupLabels) {
    var _a, _b, _c;
    var dateToday = dayjs();
    var dateYesterday = dayjs().add(-1, 'days');
    var groupedItems = items.reduce(function (list, item) {
        var date = item.timeDelivered;
        if (date instanceof moment) {
            if (moment(date.format()).isSame(dateToday.format(), 'day')) {
                list.Today.push(item);
            }
            else if (moment(date.format()).isSame(dateYesterday.format(), 'day')) {
                list.Yesterday.push(item);
            }
            else {
                list.Older.push(item);
            }
        }
        if (date instanceof dayjs) {
            if (dayjs(date.format()).isSame(dateToday, 'day')) {
                list.Today.push(item);
            }
            else if (dayjs(date.format()).isSame(dateYesterday, 'day')) {
                list.Yesterday.push(item);
            }
            else {
                list.Older.push(item);
            }
        }
        return list;
    }, {
        Today: [],
        Yesterday: [],
        Older: []
    });
    var listGroups = [];
    if (groupedItems.Today.length > 0) {
        listGroups.push({
            key: 'Today',
            name: (_a = timeGroupLabels === null || timeGroupLabels === void 0 ? void 0 : timeGroupLabels.today) !== null && _a !== void 0 ? _a : 'Today',
            startIndex: 0,
            count: groupedItems.Today.length
        });
    }
    if (groupedItems.Yesterday.length > 0) {
        listGroups.push({
            key: 'Yesterday',
            name: (_b = timeGroupLabels === null || timeGroupLabels === void 0 ? void 0 : timeGroupLabels.yesterday) !== null && _b !== void 0 ? _b : 'Yesterday',
            startIndex: groupedItems.Today.length === 0 ? 0 : groupedItems.Today.length,
            count: groupedItems.Yesterday.length
        });
    }
    if (groupedItems.Older.length > 0) {
        listGroups.push({
            key: 'Earlier',
            name: (_c = timeGroupLabels === null || timeGroupLabels === void 0 ? void 0 : timeGroupLabels.earlier) !== null && _c !== void 0 ? _c : 'Earlier',
            startIndex: ((groupedItems.Today.length === 0 ? 0 : groupedItems.Today.length)
                + (groupedItems.Yesterday.length === 0 ? 0 : groupedItems.Yesterday.length)),
            count: groupedItems.Older.length
        });
    }
    return listGroups;
}
function processNotifications(items) {
    if (!items) {
        return [];
    }
    return __spreadArrays(items).sort(function (a, b) { return SortByDate(a.timeDelivered, b.timeDelivered, true); });
}
var SortByDate = function (a, b, descending) {
    var aDayjs = a;
    var bDayjs = b;
    if (descending) {
        var c = aDayjs;
        aDayjs = bDayjs;
        bDayjs = c;
    }
    return aDayjs.diff(bDayjs);
};
//# sourceMappingURL=CoherenceNotificationPanel.base.js.map